<template>
  <cube-page title="九州通分析">
    <div class="root" slot="content">
      <wmq-layout
        ref="mainDashboard"
        :rootLayoutConfig="configData"
      />
    </div>
  </cube-page>
</template>

<script>
import { getFlowTime, getBigCustomerDetailJointown } from '@/api/bigCustomer'
import uiConfig from '@/config/ui-config/bigCustomer-joinTown-ui-config'
import CubePage from '../../components/cube-page'
import moment from 'moment'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { set } from 'lodash'

export default {
  name: 'JoinTownDetail',
  components: {
    CubePage
  },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      monthDate: undefined,
      ddiDate: undefined,
      uiConfig
    }
  },
  created () {
    getFlowTime().then((res) => {
      if (res.code === 1) {
        this.monthDate = moment(res.data.monthMaxDay)
        this.ddiDate = moment(res.data.ddiMaxDay || res.data.monthMaxDay)
        this.$refs['mainDashboard'].refreshAll()
      }
    })
  },
  provide () {
    const that = this
    return {
      requestHandler: function () {
        const params = {
          date: that.ddiDate.format('YYYY-MM-DD')
        }
        return getBigCustomerDetailJointown(params).then((res) => {
          if (res.code === 1) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].parentName !== null) {
                res.data[i].customerName =
                  '\xa0\xa0\xa0' + res.data[i].customerName
              }
            }
            const resp = {}
            resp.data = res.data
            resp.fields = {
              columns: [],
              rows: ['customerName'],
              values: ['provinceName', 'amount', 'yearAmount', 'samePeriodLastYear', 'comparedWithLastYear']
            }
            resp.meta = [
              {
                field: 'customerName',
                name: '客户名称'
              },
              {
                field: 'provinceName',
                name: '省份'
              },
              {
                field: 'amount',
                name: '当月(元)',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'yearAmount',
                name: '全年完成(元)',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'samePeriodLastYear',
                name: '去年同期(元)',
                ratio: 'YOY.V',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'comparedWithLastYear',
                name: '同比',
                ratio: 'YOY.R',
                format: {
                  suffix: '%',
                  toFixed: '0',
                  thousandsSeparatorFlag: true
                }
              }
            ]

            resp.trackId = 'bigCustomerJoinTown'
            resp.widgetType = 'table'
            res.data = resp

            return new Promise((resolve) => {
              resolve(CubeDataHandle.handleCubeData(res.data))
            })
          }
        })
      }
    }
  },
  methods: {
    filedMap (fieldValue) {
      if (fieldValue < 0) {
        return {
          fill: 'red',
          value: fieldValue / 100
        }
      }
      return { fill: '#333333' }
    }
  },
  computed: {
    configData () {
      set(uiConfig, 'schema.0.children.九州通.props.options.conditions', {
        text: [
          {
            field: 'comparedWithLastYear',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 100
      set(uiConfig, 'schema.0.children.九州通.layout.pos.h', height)
      console.log(333, uiConfig)
      return uiConfig
    }
  }
}

</script>

<style lang="stylus" scoped>

</style>
